import { fetchQuery } from 'relay-runtime';
import { graphql } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';
import createEnvironment from '../relayClientEnvironment';
import { init, getGuestUserSessionInfo } from './userTracking';

export const trackingQuery = graphql`
    query initializeTrackingQuery(
        $hasUserId: Boolean!
        $userId: String!
        $checkoutUserId: String!
        $hasCheckoutUserId: Boolean!
    ) {
        viewer {
            ...userTracking_viewer @relay(mask: false)
            user(userId: $userId) @include(if: $hasUserId) {
                ...userTracking_user @relay(mask: false)
            }
        }
    }
`;

export default async function initializeTracking(environment) {
    environment = environment || createEnvironment();
    const userId = getBuyerId(document.cookie) || '';
    const hasUserId = !!userId;
    const checkoutUserId = userId || getGuestUserSessionInfo().userId || '';
    const viewer = await fetchQuery(environment, trackingQuery, {
        userId,
        hasUserId,
        checkoutUserId,
        hasCheckoutUserId: !!checkoutUserId,
    });
    init({ viewer, user: viewer?.user, environment });
}
